<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';


export default {
    data: function() {
        return {
            
        };
    },
    props: [
        "openModal"
    ],
    methods: {
        ...mapActions({
            put: 'qmiImageGallery/put'
        }),
        ...mapActions({
            putSlick: 'slick/put'
        }),
        openModalResidenceGallery: function(index) {
            this.$eventsBus.$emit('open-modal', ['modal-residence-gallery']);
            this.$nextTick(function() {
                
              //$('.modal-residence-gallery .slick-slider').slick("getSlick").refresh();
              this.putSlick({key: 'slickImageIndex', value: index })
            });
       }

    },

    computed: {
    	...mapGetters({getData: 'modal/getData'}),
    	galleryData() {
    		return this.getData;
    	}
    }

};
</script>